import React from "react";
import AgentNewPassword from "../../organisms/AgentInitialPagesComponents/AgentNewPassword/AgentNewPassword";

const AgentNewPasswordPage = () => {
  return <AgentNewPassword />;
};

export default AgentNewPasswordPage;
